const DocumentTitleFormatter = (title, whiteLabelName) => {
  return `${title} | ${whiteLabelName}`;
};

export default DocumentTitleFormatter;
